import { ArticleParagraph2, Image, UIHeading4 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { DeactivatedLabel, Price } from '../../commonComponents';
import { WalkWayMinutes } from '../../commonComponents/WalkWayMinutes';
import { DescriptionItem } from '../DescriptionItem';
import { IOfferRowProps } from '../../../../containers/types';

export const NarrowOfferRow: React.FC<IOfferRowProps> = props => {
  const { data, onClick, isActive, isViewed, selectable } = props;

  return (
    <article
      className={cn(
        styles['container'],
        isActive && styles['active'],
        selectable && styles['selectable'],
        isViewed && styles['viewed'],
      )}
      data-name="OfferHistoryItem"
    >
      <div className={cn(styles['content'])} onClick={onClick}>
        <div className={styles['image']}>
          <Image
            width={150}
            height={150}
            objectFit="cover"
            src={data.previewPhoto || ''}
            preloader
            display="block"
            alt=""
          />
        </div>
        <div>
          {data.deactivatedTitle && (
            <div className={styles['deactivated']}>
              <DeactivatedLabel title={data.deactivatedTitle} />
            </div>
          )}
          <UIHeading4 color="primary_100">{data.title}</UIHeading4>
          {data.walkWayMinutes && <WalkWayMinutes>{data.walkWayMinutes}</WalkWayMinutes>}
          <div className={styles['price']}>
            <Price diff={data.prices.priceDiff} subprice={data.prices.priceSqm} size="XS">
              {data.prices.price}
            </Price>

            <ArticleParagraph2 color="gray60_100">{data.prices.deposit}</ArticleParagraph2>
            <ArticleParagraph2 color="gray60_100">{data.prices.agentBonusPayment}</ArticleParagraph2>
          </div>
          <div className={styles['description']}>
            <DescriptionItem title="На Циан" value={data.exposition} />
            <DescriptionItem title="Опубликовано" value={data.dateStart} />
            <DescriptionItem title="Снято" value={data.dateEnd} />
          </div>
        </div>
      </div>
    </article>
  );
};
